export const redirectToQRCode = (navigate, placa, orderId = null, paymentData = {}) => {
  const path = orderId 
    ? `/pagamento/qrcode/${placa}/${orderId}`
    : `/pagamento/qrcode/${placa}`;

  navigate(path, { state: { paymentData } });
};